export const isObject = value => typeof value === 'object' && value !== null;
export const isErrorResponse = error => isObject(error) && 'status' in error && typeof error.status === 'number' && 'data' in error && 'xhr' in error;

/**
 * Represents actual error response from a backend service.
 */

export const isServiceError = error => isObject(error) && error !== null && 'error' in error && isErrorResponse(error.error);